import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Dialog } from "primeng/dialog";
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-link-list',
  templateUrl: './link-list.component.html',
  styleUrls: ['./link-list.component.scss'],
  standalone: true,
  imports: [DialogModule, ButtonModule, FormsModule, Dialog]
})
export class LinkListComponent implements OnChanges {
  @Input() addUrlLabel: string = 'Add Links';
  @Input() placeholder: string = 'Enter a valid URL';

  @Input() initialLinks: string[] = []; // <-- new input for setting initial links
  @Output() linksChanged = new EventEmitter<string[]>();

  showUrlDeleteDialog = false;
  urlIndexToDelete: number | null = null;

  urlList: string[] = [];
  newUrl: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['initialLinks'] && changes['initialLinks'].currentValue) {
      this.urlList = this.initialLinks;
    }
  }

  addUrl() {
    if (this.isValidUrl(this.newUrl)) {
      this.urlList.push(this.newUrl.trim());
      this.newUrl = '';
      this.linksChanged.emit(this.urlList);
    } else {
      alert('Invalid URL');
    }
  }

  removeUrl(index: number) {
    this.urlList.splice(index, 1);
    this.linksChanged.emit(this.urlList);
  }

  confirmRemove(index: number) {
    this.urlIndexToDelete = index;
    this.showUrlDeleteDialog = true;
  }

  cancelUrlDeletion() {
    this.urlIndexToDelete = null;
    this.showUrlDeleteDialog = false;
  }

  confirmUrlDeletion() {
    if (this.urlIndexToDelete !== null) {
      this.urlList.splice(this.urlIndexToDelete, 1);
      this.linksChanged.emit(this.urlList);
      this.cancelUrlDeletion();
    }
  }

  isValidUrl(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  }

  reset() {
    this.urlList = [];
    this.newUrl = '';
    this.linksChanged.emit([]);
  }
}